import { Button } from "@mui/material";
import React from "react";

export default function CoreTextButton(props) {
  return (
    <Button varient="text" {...props}>
      {props?.children}
    </Button>
  );
}
